import { IVideoGif, IVideoData } from './types'

export const mapGifPropsToVideo = ({
    id,
    user,
    rating,
    tags,
    title,
    images: { fixed_height, source, original },
}: IVideoGif): IVideoData => ({
    id,
    user,
    rating,
    tags,
    uid: id,
    title: title ? title.replace('GIF', 'Video') : 'Untitled',
    description: '',
    source_url: '',
    duration: 0,
    url: `${window.location.origin}/videos/${id}`,
    media: {
        assets: [
            {
                width: parseInt(String(source.width)),
                height: parseInt(String(source.height)),
                file_size: source.size,
                bit_rate: '',
                url: source.url.indexOf('.mp4') > -1 || source.url.indexOf('.mov') > -1 ? source.url : original.mp4,
                is_source: false,
                format: 'mp4',
                duration: 0,
                frame_rate: 29.970029830932617,
                has_audio: true,
            },
        ],
        previews: [
            {
                format: 'gif',
                width: parseInt(String(fixed_height.width)),
                height: parseInt(String(fixed_height.height)),
                url: fixed_height.url,
                file_size: fixed_height.size,
            },
        ],
    },
})
